import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pathToSentence'
})
export class PathToSentencePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    // Remove trailing slashes and split the path
    const segments = value.split('/').filter(segment => segment.trim().length > 0); // Remove empty parts

    if (segments.length === 0) return '';

    const lastSegment = segments[segments.length - 1];

    // Convert kebab-case to sentence case
    const sentence = lastSegment.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

    return sentence;
  }
}
